import { declare } from "csi/def/ActionFactory";
import { Context } from "csi/def/Context";
import _StateAction from "./_StateAction";

const MassUpdateDataSheets = declare("MassUpdateDataSheets", _StateAction, {
	m_tag: "MassUpdateDataSheets",

	hasAccess(ctx: Context) {
		// hide action if this is first revision
		const firstRevisionURL = ctx.getParent().Revisions.first();
		if (ctx.getNodeURL() === firstRevisionURL) {
			return false;
		}
		return this.inherited(arguments);
	},
});

export = MassUpdateDataSheets;